<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" :disabled="!hasClaim('CorrectiveActionRequestFullWriteAccess')">
            <template v-slot:field="{ item }">
                <v-textarea v-model="item.memberComments" label="Member Comments" />
            </template>
        </form-base>
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" :disabled="!hasClaim('CorrectiveActionRequestFullWriteAccess')">
            <template v-slot:field="{ item }">
                <v-textarea v-model="item.memberComments" label="Member Comments" @change="$emit('change')"  />
            </template>
        </card-base>
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import severityEnum from '../enums/severity'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                auditForm: () => import('../forms/AuditForm'),
                fields: [
                    { type: 'autocomplete', text: 'Audit', value: 'auditId', rules: [v => !!v || 'Audit is required'], isRequired: true, form: () => import('./AuditForm'), apiMethod: 'Audits', claim: 'Audits' },
                    { type: 'textarea', text: 'Description', value: 'description', rules: [v => !!v || 'Description is required'], isRequired: true, maxLength: false },
                    { type: 'enum', text: 'Severity', value: 'severity', rules: [v => (v !== null && v !== '') || 'Severity is required'], isRequired: true, items: enumService.enumAsSelectList(severityEnum) },
                    { type: 'datetime', text: 'Raised At', value: 'raisedAt', rules: [v => !!v || 'Raised At is required'], isRequired: true },
                    { type: 'datetime', text: 'Rectified On', value: 'rectifiedOn', rules: [] },
                    { type: 'custom' },
                ],
                formTitle: 'Corrective Action Request',
            }
        },

        computed: {
            apiMethod() {
                return this.hasClaim('CorrectiveActionRequestFullWriteAccess') ? 'CorrectiveActionRequests' : 'CorrectiveActionRequests/MemberComments';
            }
        }
    };
</script>
